import { render } from "./building_info.vue?vue&type=template&id=02b3fdee&scoped=true"
import script from "./building_info.vue?vue&type=script&lang=js"
export * from "./building_info.vue?vue&type=script&lang=js"

import "./building_info.vue?vue&type=style&index=0&id=02b3fdee&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02b3fdee"]])

export default __exports__